document.addEventListener('DOMContentLoaded', () => {
  const passwordForm = document.querySelector('[data-password-form]');
  const passwordToggle = document.querySelector('[data-password-toggle]');

  if (passwordToggle) {
    passwordToggle.addEventListener('click', () => {
      passwordForm.classList.toggle('hidden');
    });
  }
});
